import { ChangeDetectionStrategy, Component, Input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '@libs/components/icons';
import { LinkDirective } from '@libs/shared/ui';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@libs/shared/auth';
import { HeaderModel } from './header.model';

@Component({
  selector: 'ui-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LinkDirective,
    IconComponent,
  ],
})
export class HeaderComponent {
  @Input() public data?: HeaderModel;

  public readonly isAuthorized: Signal<boolean | undefined> = toSignal(this.authService.isUserAuthorized$());

  public constructor(
    private readonly authService: AuthService,
  ) {
  }

  public login(): void {
    void firstValueFrom(this.authService.login());
  }

  public logout(): void {
    void firstValueFrom(this.authService.logout());
  }
}
